import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { PRO_PRICE_LABEL } from '../pricing';
import SupplierInvoices from '../components/costs/SupplierInvoices';
import BillsList from '../components/costs/BillsList';

/** Money out: supplier invoices and bills paid. Invoices are Pro-only (as they
 *  were on the Upload page); the bills list shows for everyone who has bills. */
export default function CostsPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isPro = user?.plan === 'pro';

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, ease: 'easeOut' }}>
      <h1 className="font-serif text-2xl text-[#2D2A2E] mb-6">Costs</h1>

      {isPro ? (
        <SupplierInvoices />
      ) : (
        <div className="bg-white border border-[#E6E2DE] rounded-[14px] p-10 text-center shadow-card">
          <div className="w-16 h-16 rounded-full bg-[#4A2D5E]/10 flex items-center justify-center mx-auto mb-4">
            <Lock size={28} strokeWidth={1.5} className="text-[#4A2D5E]" />
          </div>
          <h2 className="font-serif text-xl text-[#2D2A2E] mb-2">Pro Feature</h2>
          <p className="font-sans text-sm text-[#6B6670] max-w-md mx-auto mb-6">
            Add what your suppliers charge you and your margin numbers become real, not estimates.
          </p>
          <button
            onClick={() => navigate('/settings/account')}
            className="bg-[#4A2D5E] text-white hover:bg-[#3D254D] rounded-[8px] shadow-sm font-sans font-medium px-8 py-3 transition-colors"
          >
            Upgrade to Pro — {PRO_PRICE_LABEL}/mo
          </button>
        </div>
      )}

      <BillsList />
    </motion.div>
  );
}
